import { render, staticRenderFns } from "./sample-tickets.vue?vue&type=template&id=e0b626c4&"
import script from "./sample-tickets.vue?vue&type=script&lang=js&"
export * from "./sample-tickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports